/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  function updateProductButtonLayout(form) {
    if (!form) return;

    var paymentContainer = form.querySelector('.product-form__payment-container');
    var quantityContent = form.querySelector('.product-form__info-item--quantity .product-form__info-content');
    if (!paymentContainer || !quantityContent) return;

    var addButton = form.querySelector('.product-form__add-button');
    if (!addButton) return;

    var desktop = window.matchMedia('(min-width: 641px)').matches;

    if (addButton.parentElement !== quantityContent) {
      quantityContent.appendChild(addButton);
    }

    quantityContent.classList.add('product-form__info-content--with-add');
    quantityContent.classList.toggle('product-form__info-content--with-add-mobile', !desktop);
  }

  function applyLayoutToAllForms() {
    document.querySelectorAll('form.product-form').forEach(updateProductButtonLayout);
  }

  document.addEventListener('DOMContentLoaded', applyLayoutToAllForms);
  window.addEventListener('resize', applyLayoutToAllForms);
  document.addEventListener('shopify:section:load', applyLayoutToAllForms);
  document.addEventListener('shopify:section:reorder', applyLayoutToAllForms);
  document.addEventListener('shopify:block:select', applyLayoutToAllForms);
})();

/**
 * Sort product lists to show in-stock items first
 */
(function () {
  function sortInStockFirst() {
    document.querySelectorAll('.product-list--collection').forEach(function (list) {
      var items = Array.from(list.children).filter(function (el) {
        return el.classList.contains('product-item');
      });
      if (items.length === 0) return;

      var inStock = [];
      var outOfStock = [];

      items.forEach(function (item) {
        if (item.getAttribute('data-available') === 'true') {
          inStock.push(item);
        } else {
          outOfStock.push(item);
        }
      });

      inStock.concat(outOfStock).forEach(function (item) {
        list.appendChild(item);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', sortInStockFirst);
  document.addEventListener('shopify:section:load', sortInStockFirst);
  document.addEventListener('theme:loading:end', sortInStockFirst);
})();

/**
 * Nav bar drag-to-scroll with visual scroll indicators
 */
(function () {
  function initNavScroll() {
    var list = document.querySelector('.nav-bar__linklist');
    var container = list && list.closest('.container');
    if (!list || !container) return;

    var isDown = false;
    var startX, scrollLeft, hasDragged;
    var DRAG_THRESHOLD = 5;

    // Add scroll indicator wrapper
    container.classList.add('nav-scroll-container');

    // Update fade indicators based on scroll position
    function updateFades() {
      var canScrollLeft = list.scrollLeft > 2;
      var canScrollRight = list.scrollLeft < list.scrollWidth - list.clientWidth - 2;
      container.classList.toggle('nav-scroll--left', canScrollLeft);
      container.classList.toggle('nav-scroll--right', canScrollRight);
    }

    window.addEventListener('resize', updateFades);
    updateFades();

    // Drag on anything including links
    list.addEventListener('mousedown', function (e) {
      isDown = true;
      hasDragged = false;
      startX = e.pageX;
      scrollLeft = list.scrollLeft;
    });

    list.addEventListener('mouseleave', function () {
      isDown = false;
      list.classList.remove('is-dragging');
    });

    list.addEventListener('mouseup', function () {
      isDown = false;
      list.classList.remove('is-dragging');
    });

    list.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var dx = e.pageX - startX;
      if (!hasDragged && Math.abs(dx) > DRAG_THRESHOLD) {
        hasDragged = true;
        list.classList.add('is-dragging');
      }
      if (hasDragged) {
        e.preventDefault();
        list.scrollLeft = scrollLeft - dx;
      }
    });

    // Only prevent click if user actually dragged
    list.addEventListener('click', function (e) {
      if (hasDragged) {
        e.preventDefault();
        e.stopPropagation();
        hasDragged = false;
      }
    }, true);

    // Show custom scrollbar thumb if content overflows
    function updateScrollbar() {
      var track = container.querySelector('.nav-scroll-track');
      if (list.scrollWidth <= list.clientWidth) {
        if (track) track.style.display = 'none';
        return;
      }
      if (!track) {
        track = document.createElement('div');
        track.className = 'nav-scroll-track';
        track.innerHTML = '<div class="nav-scroll-thumb"></div>';
        container.appendChild(track);
      }
      track.style.display = '';
      // Match track width to the linklist's visible width
      var listRect = list.getBoundingClientRect();
      var containerRect = container.getBoundingClientRect();
      track.style.width = listRect.width + 'px';
      track.style.left = (listRect.left - containerRect.left) + 'px';

      var thumb = track.querySelector('.nav-scroll-thumb');
      var ratio = list.clientWidth / list.scrollWidth;
      var thumbWidth = Math.max(ratio * 100, 20);
      var scrollRatio = list.scrollLeft / (list.scrollWidth - list.clientWidth);
      var trackSpace = 100 - thumbWidth;
      thumb.style.width = thumbWidth + '%';
      thumb.style.left = (scrollRatio * trackSpace) + '%';
    }

    var scrollRAF;
    list.addEventListener('scroll', function () {
      updateFades();
      if (scrollRAF) cancelAnimationFrame(scrollRAF);
      scrollRAF = requestAnimationFrame(updateScrollbar);
    }, { passive: true });
    window.addEventListener('resize', updateScrollbar);
    updateScrollbar();

    // Make the scrollbar thumb draggable
    var thumbDragging = false;
    var thumbStartX, thumbScrollLeft;

    container.addEventListener('mousedown', function (e) {
      var thumb = e.target.closest('.nav-scroll-thumb');
      var trackEl = e.target.closest('.nav-scroll-track');
      if (!thumb && !trackEl) return;

      e.preventDefault();
      e.stopPropagation();

      if (thumb) {
        thumbDragging = true;
        thumbStartX = e.pageX;
        thumbScrollLeft = list.scrollLeft;
        thumb.classList.add('is-active');
      } else if (trackEl) {
        // Click on track: jump to that position
        var trackRect = trackEl.getBoundingClientRect();
        var clickRatio = (e.pageX - trackRect.left) / trackRect.width;
        list.scrollLeft = clickRatio * (list.scrollWidth - list.clientWidth);
      }
    });

    document.addEventListener('mousemove', function (e) {
      if (!thumbDragging) return;
      e.preventDefault();
      var track = container.querySelector('.nav-scroll-track');
      if (!track) return;
      var dx = e.pageX - thumbStartX;
      var trackWidth = track.offsetWidth;
      var scrollRange = list.scrollWidth - list.clientWidth;
      var ratio = list.clientWidth / list.scrollWidth;
      var thumbWidth = Math.max(ratio, 0.2);
      var draggableRange = trackWidth * (1 - thumbWidth);
      list.scrollLeft = thumbScrollLeft + (dx / draggableRange) * scrollRange;
    });

    document.addEventListener('mouseup', function () {
      if (thumbDragging) {
        thumbDragging = false;
        var thumb = container.querySelector('.nav-scroll-thumb');
        if (thumb) thumb.classList.remove('is-active');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initNavScroll);
})();

/**
 * Mega menu: lazy-load collection images on first hover
 */
(function () {
  function initMegaMenuLazy() {
    document.querySelectorAll('.nav-bar__item').forEach(function (item) {
      var loaded = false;
      item.addEventListener('mouseenter', function () {
        if (loaded) return;
        loaded = true;
        var panel = item.querySelector('.nav-megamenu-grid');
        if (!panel) return;
        panel.querySelectorAll('img[data-src]').forEach(function (img) {
          img.src = img.getAttribute('data-src');
          var srcset = img.getAttribute('data-srcset');
          if (srcset) img.srcset = srcset;
          img.removeAttribute('data-src');
          img.removeAttribute('data-srcset');
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initMegaMenuLazy);
})();

/**
 * Homepage Judge.me cards-carousel: enable native finger-swipe on mobile.
 *
 * Judge.me's carousel binds non-passive touch/pointer handlers across the
 * widget — on the inner videos-container, on each card (tap-to-open lightbox),
 * and via delegation. Any of those calling preventDefault on touchmove kills
 * the overflow-x:auto + scroll-snap strip the CSS sets up on mobile.
 *
 * Fix: capture-phase, passive listeners registered at document for every
 * touch/pointer event. Because custom.js is `defer`-loaded before JM's app
 * block scripts run, ours register first — so in the capture phase they fire
 * before any JM handler reaches the target and call stopImmediatePropagation,
 * preventing every JM touch/pointer handler inside the carousel from running.
 *
 * Browser-native horizontal scrolling still happens (passive = we can't
 * preventDefault), and synthesized `click` events still fire on tap (we only
 * block touch/pointer), so the lightbox-on-tap behavior is preserved.
 */
(function () {
  if (!document.body.classList.contains('template-index')) return;
  var mq = window.matchMedia('(max-width: 640px)');
  var EVENTS = [
    'touchstart', 'touchmove', 'touchend', 'touchcancel',
    'pointerdown', 'pointermove', 'pointerup', 'pointercancel'
  ];

  function intercept(e) {
    if (!mq.matches) return;
    var t = e.target;
    if (t && t.closest && t.closest('.template-index .jdgm-cards-carousel')) {
      e.stopImmediatePropagation();
    }
  }

  EVENTS.forEach(function (evt) {
    document.addEventListener(evt, intercept, { capture: true, passive: true });
  });
})();
/* push 1779508521 */
